import React, { useState,useEffect } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import { ListGroup, Row, Col, Container, Table } from 'react-bootstrap';


function trova_componenti_nella_data(data) {

    var dateObj = new Date(data);
    var month_inizio = dateObj.getUTCMonth() + 1; //months from 1-12
    var year_inizio = dateObj.getUTCFullYear() ; //months from 1-12

    var day_inizio = dateObj.getUTCDate();

    const weekday = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];
    let day_settimana = weekday[dateObj.getDay()];
    var giorno_inizio = day_settimana + " - " + day_inizio + "/" + month_inizio + "/" + year_inizio;

    return giorno_inizio;
}

const Visualizza_singolo_progetto = (props) => {

    useEffect(() => {
      
    }, [props.progetto]);
//    const [somma, calcola_somma] = useState('');
    function controllo_che_la_ditta_abbia_confermato_stage(confermata) {
 
        if (confermata === -2) {
            return <div>
                Mail Inizio Stage non inviata
            </div>
        }
        if (confermata === -1) {
            return <> Mail inizio stage: In attesa di conferma: ? </>
        }
        if (confermata === 0) {
            return <> Mail inizio stage: Non confermata &#10060; </>
        }
        if (confermata === 1) {
            return <> Mail inizio stage: Confermata:  &#9989; </>
        }
    }


    function progetto_dentro_il_periodo_stage(data_inizio, data_fine) {
        //        console.log('date')
        //        console.log(data_inizio)
        //        console.log(data_fine)

        var date_start = new Date(data_inizio);


        var date_end = new Date(data_fine);
        if (Date.now() < date_start || Date.now() > date_end) {
            return <>
                &#10060;
            </>
        }
        return <>
            &#9989;
        </>

    }

    function controllo_che_il_progetto_attivo(progetto_attivo) {
        //        console.log('date')
        //        console.log(data_inizio)
        //        console.log(data_fine)
        if (progetto_attivo) {
            return <>
                &#9654;
            </>
        }
        if (!progetto_attivo) {
            return <>

                &#x23E9;
        </>
        }
    }
    return (
        <Container>
        <Row>
        <Col>
        <ul>
            <li>
                <label>
                Alunno: <strong> {props.progetto.id_alunno.cognome} {props.progetto.id_alunno.nome} </strong></label>
                {props.progetto.alunno_collegato != undefined &&  <label> <strong>  {props.progetto.alunno_collegato[0].cognome} {props.progetto.alunno_collegato[0].nome} </strong></label>}    
            </li>
            <li>

            {/* parte per il lookup */ }    
                Ragione Sociale: <strong>  {props.progetto.id_ditta !== null && <> {props.progetto.id_ditta.ragione_sociale} </>} </strong>
                {props.progetto.ditta_collegata != undefined &&  <label> <strong>{props.progetto.ditta_collegata[0].ragione_sociale}  </strong></label>}    
            </li>

        </ul>
        </Col>
        <Col>
            <Row >
                    <span>
                {progetto_dentro_il_periodo_stage(props.progetto.data_inizio, props.progetto.data_fine)}
                {controllo_che_il_progetto_attivo(props.progetto.progetto_attivo)}
     
                {controllo_che_la_ditta_abbia_confermato_stage(props.progetto.stage_confermato_dalla_ditta)}
                </span>
                
            </Row>
            <Row> 
                <small>
                 <span> Inizio: <strong> {trova_componenti_nella_data(props.progetto.data_inizio)} </strong> </span>
                 <span> Fine: <strong> {trova_componenti_nella_data(props.progetto.data_fine)} </strong> </span>
                 </small>

                  

            </Row>
     

        </Col>
      
    </Row>
    </Container>
    )
}
export default Visualizza_singolo_progetto;